<template>
  <div v-if="show">
    <div v-if="!edit">
      Job Title: {{ work_experience_data.job_title }}<br/>
      Company: {{ work_experience_data.company }}<br/>
      Description: {{ work_experience_data.description }}<br/>
      Start Date: {{ formatDate(work_experience_data.start_date) }}<br/>
      End Date: {{ formatDate(work_experience_data.end_date) }}<br/>
    </div>
    <form @submit.prevent="createOrUpdate" v-if="edit">
      <div class="form-group">
        <input type="hidden" name="id" v-model="work_experience_data.id">
        Job Title:
        <input class="form-control" type="text" name="job_title" id="job_title" v-model="work_experience_data.job_title" required/><br/>
        Company:
        <input class="form-control" type="text" name="company" id="company" v-model="work_experience_data.company" required/><br/>
        Description:
        <input class="form-control" type="text" name="description" id="description" v-model="work_experience_data.description" required/><br/>
        Start Date:
        <input class="form-control" type="date" name="start_date" id="start_date" v-model="work_experience_data.start_date" required/><br/>
        End Date:
        <input class="form-control" type="date" name="end_date" id="end_date" v-model="work_experience_data.end_date" required/><br/>
        <button class="btn btn-form better_font" type="submit">Update</button>
      </div>
    </form>
    <div v-if="!edit">
      <button class="btn btn-form better_font mr-1" @click.prevent="toggleEdit">Edit</button>
      <button class="btn btn-danger better_font" @click.prevent="deleteWorkExperience(work_experience_data.id)">Delete</button>
    </div>
    <hr/>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: "work_experience",
  props:{
    work_experience_data: Object
  },
  data(){
    return{
      errors: [],
      show: true,
      edit: true,
    }
  },
  mounted(){
    this.checkId()
  },
  methods:{
    checkId(){
      if(!this.work_experience_data.id)
        this.edit = true
    },
    updateWorkExperience(data){
      axios.put(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/work_experiences/` + data.work_experience.id,
        data
      )
    },
    createWorkExperience(data){
      axios.post(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/work_experiences/`,
        data
      )
    },
    deleteWorkExperience(work_exp_id){
      if(work_exp_id)
        axios.delete(`${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/work_experiences/` + work_exp_id)
      this.show = false
    },
    createOrUpdate(event){
      if(event.target[0].name == 'id' && event.target[0].value !== ''){
        this.updateWorkExperience(this.dataFormatter(event.target))
      }else{
        this.createWorkExperience(this.dataFormatter(event.target))
      }
      this.edit = false
    },
    dataFormatter(form_input_data){
      let ready = {work_experience:{}}
      Array.from(form_input_data).forEach( el => {
        if(el.name)
          ready.work_experience[el.name] = el.value
      })
      return ready
    },
    toggleEdit(){
      this.edit = !this.edit
    },
    formatDate(date){
      return date.substr(5, 2) + '/' + date.substr(8, 2) + '/'+ date.substr(0, 4)
    }
  }
}
</script>

<style>

.btn-form {
  background-color: #27AAE1;
  color: white;
}

.btn-form:hover {
  background-color: #1B86B5;
}

</style>
